module.exports = __webpack_public_path__ + "static/media/si.01f1cefd.svg";